import {
  SELECT_COUNTRY,
  HANDLE_FOCUS,
  HANDLE_BLUR,
  SHOW_PSTN,
  HIDE_PSTN,
  VIDEO_MUTED,
  AUDIO_MUTED,
  IS_JOIN_CALL,
  CANCEL_JOIN_CALL,
  RESET_GUEST_CALL
} from 'constants/JoinModal';

export function isJoinModalCall() {
  return {
    type: IS_JOIN_CALL
  };
}

export function cancelJoinCall() {
  return {
    type: CANCEL_JOIN_CALL
  };
}

export function selectCountry(country) {
  return {
    type: SELECT_COUNTRY,
    payload: country
  };
}

export function handleFocus() {
  return {
    type: HANDLE_FOCUS
  };
}

export function handleBlur() {
  return {
    type: HANDLE_BLUR
  };
}
export function showPSTN() {
  return {
    type: SHOW_PSTN
  };
}

export function hidePSTN() {
  return {
    type: HIDE_PSTN
  };
}

export function toggleVideoMuted(toggle) {
  return {
    type: VIDEO_MUTED,
    payload: toggle
  };
}

export function toggleAudioMuted(toggle) {
  return {
    type: AUDIO_MUTED,
    payload: toggle
  };
}

export function resetGuestCall() {
  return {
    type: RESET_GUEST_CALL
  };
}

export default {
  isJoinModalCall,
  cancelJoinCall,
  selectCountry,
  handleBlur,
  handleFocus,
  showPSTN,
  hidePSTN,
  toggleVideoMuted,
  toggleAudioMuted,
  resetGuestCall
};
